/**
 * Playful theme identifiers enum - NO STRING LITERALS!
 * SYNC: Keep in sync with REGISTERED_PLAYFUL_THEMES in registry.ts
 */
export enum PlayfulThemeId {
  OFF = 'off',
  SPACE = 'space',
  OCEAN_WAVES = 'ocean_waves',
  JUNGLE = 'jungle',
  CANDY = 'candy',
  ROBOT = 'robot',
  MAGIC = 'magic',
  DOODLE = 'doodle',
}
